import React from 'react';
import Tooltip from './Tooltip';
import { dummyClick } from '../utilities';

const Poppin = ({ id, body, posX, posY, owned, zIndex, opened, onMouseDown }) => (
  <div
    id={`pin_${id}`}
    className="a-pin"
    onMouseDown={onMouseDown}
    style={{
      left: (posX * 100 + '%'),
      top: (posY * 100 + '%'),
      zIndex: zIndex
    }}
  >
    <img src={`/images/webreader/poppin${owned?'-own':''}.svg`}/>
    { opened && <Tooltip body={body} posX={posX} posY={posY} /> }
  </div>
);

Tooltip.defaultProps = {
  id: 1,
  body: 'EN Welcome from Tooltip',
  posX: 0,
  posY: 0,
  owned: false,
  zIndex: 2,
  opened: false,
  onMouseDown: dummyClick
};

export {Poppin};